import React, { memo } from 'react';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import type { DeepDiveProviderProps } from '../../common/types.tsx';
import { DeepDiveCardProvider as DeepDiveCardProviderBase } from './main.tsx';

const isEqual = (prev: DeepDiveProviderProps, next: DeepDiveProviderProps) =>
	prev.recentProjects === next.recentProjects &&
	prev.recent2QueuesByRecentProjects === next.recent2QueuesByRecentProjects &&
	prev.isLoading === next.isLoading;

const DeepDiveCardProviderCurrent = memo<DeepDiveProviderProps>(
	(props: DeepDiveProviderProps) => <DeepDiveCardProviderBase {...props} />,
	isEqual,
);

const isEqualExp = (prev: DeepDiveProviderProps, next: DeepDiveProviderProps) =>
	prev.recentProjects === next.recentProjects &&
	prev.recent2QueuesByRecentProjects === next.recent2QueuesByRecentProjects &&
	prev.isLoading === next.isLoading &&
	prev.recommendedProjectsData === next.recommendedProjectsData;

const DeepDiveCardProviderExp = memo<DeepDiveProviderProps>(
	(props: DeepDiveProviderProps) => <DeepDiveCardProviderBase {...props} />,
	isEqualExp,
);

export const DeepDiveCardProvider = componentWithCondition(
	() => expValEquals('recommended_projects_for_you_page', 'cohort', 'test', 'control'),
	DeepDiveCardProviderExp,
	DeepDiveCardProviderCurrent,
);
